function readString(
    source: Record<string, unknown>,
    ...keys: string[]
): string {
    for (const key of keys) {
        const value = source[key];
        if (typeof value === "string" && value.length > 0) {
            return value;
        }
    }
    return "";
}

function readStringArray(
    source: Record<string, unknown>,
    ...keys: string[]
): string[] {
    for (const key of keys) {
        const value = source[key];
        if (!Array.isArray(value)) {
            continue;
        }
        return value
            .filter((item): item is string => typeof item === "string")
            .filter(Boolean);
    }
    return [];
}

function readBoolean(
    source: Record<string, unknown>,
    ...keys: string[]
): boolean {
    for (const key of keys) {
        const value = source[key];
        if (typeof value === "boolean") {
            return value;
        }
        if (typeof value === "number") {
            return value === 1;
        }
        if (typeof value === "string") {
            const normalized = value.trim().toLowerCase();
            if (normalized === "true" || normalized === "1") {
                return true;
            }
            if (normalized === "false" || normalized === "0") {
                return false;
            }
        }
    }
    return false;
}

function readNumber(
    source: Record<string, unknown>,
    ...keys: string[]
): number {
    for (const key of keys) {
        const value = source[key];
        if (typeof value === "number" && !Number.isNaN(value)) {
            return value;
        }
        const parsed = Number(value);
        if (!Number.isNaN(parsed)) {
            return parsed;
        }
    }
    return 0;
}

export { readBoolean, readNumber, readString, readStringArray };
